<template>
  <div class="flex flex-col md:flex-row pt-8 md:pt-16" v-for="item in items" :key="item.id">
    <div class="w-full md:w-1/2">
        <img class="w-auto h-full object-cover" :src="item.imageUrl" alt="">
    </div>
    <div class="w-full md:w-1/2 md:pl-6">
      <h2 class="font-semibold text-mainColor text-xl">{{ item.name }}</h2>
      <p class="pt-3 text-justify">{{ item.description }}</p>
    </div>
  </div>
</template>

<script>
import { db } from "@/firebaseConfig";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
export default {
  name: "SecurityTrainingContent",
  data() {
    return {
      items: [],
    };
  },
  mounted() {
    this.fetchBanners();
  },
  methods: {
    async fetchBanners() {
      const q = query(collection(db, "securityTrainingContent"), orderBy("date", "asc"));
      const snapshot = await getDocs(q);
      this.items = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    },
  },
};
</script>
